export function enumProp(values, extras = {}) {
    return Object.freeze({
        type: 'enum',
        values,
        ...extras,
    });
}
export function stringProp(extras = {}) {
    return Object.freeze({
        type: 'string',
        ...extras,
    });
}
export function breakpointProp(extras = {}) {
    return Object.freeze({
        type: 'string',
        format: 'breakpoint',
        ...extras,
    });
}
export function numberProp(extras = {}) {
    return Object.freeze({
        type: 'number',
        ...extras,
    });
}
export function stringOrNumberProp(extras = {}) {
    return Object.freeze({
        type: 'string_or_number',
        ...extras,
    });
}
export function stringOrStringArrayProp(extras = {}) {
    return Object.freeze({
        type: 'string_or_string_array',
        ...extras,
    });
}
export function boolProp(defaultValue, extras = {}) {
    return Object.freeze({
        type: 'bool',
        ...(defaultValue !== undefined && { default: defaultValue }),
        ...extras,
    });
}
export function spacingProp(extras = {}) {
    return Object.freeze({
        type: 'spacing_token',
        ...extras,
    });
}
export function borderProp(extras = {}) {
    return Object.freeze({
        type: 'border_token',
        ...extras,
    });
}
export function borderWidthProp(extras = {}) {
    return Object.freeze({
        type: 'border_width_token',
        ...extras,
    });
}
export function borderStyleProp(extras = {}) {
    return Object.freeze({
        type: 'border_style_token',
        ...extras,
    });
}
export function colorTokenProp(extras = {}) {
    return Object.freeze({
        type: 'color_token',
        ...extras,
    });
}
export function sizeTokenProp(extras = {}) {
    return Object.freeze({
        type: 'size_token',
        ...extras,
    });
}
export function radiusTokenProp(extras = {}) {
    return Object.freeze({
        type: 'radius_token',
        ...extras,
    });
}
export function shadowTokenProp(extras = {}) {
    return Object.freeze({
        type: 'shadow_token',
        ...extras,
    });
}
export function zIndexTokenProp(extras = {}) {
    return Object.freeze({
        type: 'z_index_token',
        ...extras,
    });
}
export function contentProp(extras = {}) {
    return Object.freeze({
        type: 'content',
        ...extras,
    });
}
export function objectProp(properties, extras = {}) {
    return Object.freeze({
        type: 'object',
        properties: Object.freeze({ ...properties }),
        ...extras,
    });
}
export function arrayProp(items, extras = {}) {
    return Object.freeze({
        type: 'array',
        items,
        ...extras,
    });
}
export function propsRecord(props) {
    return Object.freeze({ ...props });
}
//# sourceMappingURL=schema-prop-builders.js.map